<div class="node setBg" (click)="clickRel.emit(rel)" *ngIf="rel.url" [ngStyle]="{'background-image': 'url(' +rel.url+ ')'}">
  {{rel.relation}}
</div>
<div class="node" (click)="clickRel.emit(rel)" *ngIf="!rel.url">
  {{rel.relation}}
</div>
<span *ngIf="rel.name">{{rel.name}}</span>
<!-- <span *ngIf="!rel.name">Add</span> -->